// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/en/spring-manufacturing-techniques/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const springManufacturingTechniquesEN: PageEntry = {
  id: "post.federherstellungstechniken",
  locale: "en",
  slug: "spring-manufacturing-techniques",
  seo: {
    title: "Glossary: Spring manufacturing techniques explained simply | Dietz GmbH",
    description: "Spring manufacturing techniques include various methods and processes that are used in the production of springs. These include wire drawing, bending, coiling, heat treatment and s",
  },
  type: "post",
  h1: "Glossary: Spring manufacturing techniques explained simply",
  intro: "Spring manufacturing techniques include various methods and processes that are used in the production of springs. These include wire drawing, bending, coiling, heat treatment and surface coating. Each technique has specific applications and benefits, depending on the requirements of the spring and the end application. Advancing technology in the manufacturing industry has led to innovative manufacturing techniques that improve the precision, efficiency and quality of the springs produced. Understanding the different spring manufacturing techniques is critical to selecting the appropriate method depending on the specific requirements of a project.",
  blocks: [

  ],
};
